import { useContext } from "react";
import { AuthContext } from "./Utils/AuthContext";
import { Navigate, Outlet } from "react-router-dom";
function Protect() {
  const { user } = useContext(AuthContext);
  return user ? <Outlet /> : <Navigate to="/" />;
}

export default Protect;
